import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { ContactType } from "../../enums";
import AntIcon from "../icons/AntIcon";

interface Props {
  type: ContactType;
  color?: "blue" | "green" | "red" | "orange" | "grey";
  showTooltip?: boolean;
}

export const ContactTypeIcon = ({ type, color, showTooltip }: Props) => {
  const { t } = useTranslation();

  switch (type) {
    case ContactType.EMAIL:
    case ContactType.MAIN_EMAIL:
      return (
        <Tooltip title={showTooltip ? t(`contact.enums.type.${type}`) : undefined}>
          <span>
            <AntIcon type="mail" color={color} />
          </span>
        </Tooltip>
      );
    case ContactType.PHONE_NUMBER:
    case ContactType.MAIN_PHONE_NUMBER:
      return (
        <Tooltip title={showTooltip ? t(`contact.enums.type.${type}`) : undefined}>
          <span>
            <AntIcon type="phone" color={color} />
          </span>
        </Tooltip>
      );
    case ContactType.OTHER:
      return (
        <Tooltip title={showTooltip ? t(`contact.enums.type.${type}`) : undefined}>
          <span>
            <AntIcon type="contact" color={color} />
          </span>
        </Tooltip>
      );
    default:
      return null;
  }
};
